"use client";

import { useState } from "react";
import s from "./style.module.scss";
import Accordion from "./Accordion/Accordion";
import { PageWrapper } from "../PageWrapper";
import { useSectionsData } from "../../utils/useSectionsData.ts";

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleAnswer = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = useSectionsData();
  const faqSection = sections.pp_v7_faq_section;
  const heading = faqSection.tr_heading;
  const faqs = faqSection?.faqs;

  return (
    <PageWrapper backgroundColor="section_white">
      <div className={s.faq}>
        <p
          className={s.faq__title}
          dangerouslySetInnerHTML={{ __html: heading }}
        />
        <div className={s.faq__questionsContainer}>
          {faqs?.map(
            (
              faq: { tr_question: string; tr_answer: string },
              index: number
            ) => (
              <Accordion
                key={index}
                index={index}
                title={faq?.tr_question}
                description={faq?.tr_answer}
                isOpen={index === openIndex}
                toggle={toggleAnswer}
                size="large"
              />
            )
          )}
        </div>
      </div>
    </PageWrapper>
  );
};
